
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/acheter/guide/preparer-son-achat",
      function () {
        return require("private-next-pages/acheter/guide/preparer-son-achat/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/acheter/guide/preparer-son-achat"])
      });
    }
  